import { DateTime } from 'luxon';

export function onToday(setSelectedDate: (date: DateTime) => void): () => void {
  return () => {
    setSelectedDate(DateTime.local());
  };
}
